module.exports = __webpack_public_path__ + "img/informatics.9a0483c9.png";